<template>
  <v-container>
    <v-row>
      <v-col cols="5" offset="4">
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center">Movimiento de entrada</v-card-title>
          <v-card-text>
            <v-container>
              <v-form v-model="movimientoForm">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model.number="movimiento.cantidad"
                      type="number"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      min="0"
                    >
                      <template v-slot:label>Cantidad <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="movimiento.observaciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Observaciones"
                      no-resize
                      rows="4"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text class="error--text mb-4 mx-8" v-on:click="$router.go(-1)">Cancelar</v-btn>
            <v-btn
              color="secondary"
              class="primary--text mb-4"
              :loading="loading"
              v-on:click="triggerMovimiento()"
              :disabled="movimiento.cantidad == 0 || loading"
              >Guardar movimiento</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  async mounted() {
    await this.fetchTipoMovimiento()
  },

  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      movimientoForm: false,
      loading: false,
      movimiento: {
        fk_idCatItem: this.id,
        fk_idcatTipoMovimiento: 1,
        cantidad: 0,
        observaciones: '',
      },

      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    ...mapGetters('tipoMovimientoEquipamiento', {
      tipoMovimiento: 'getTipoMovimiento',
    }),
  },

  methods: {
    ...mapActions('movimientoEquipamiento', ['saveMovimientoEquipamiento']),
    ...mapActions('tipoMovimientoEquipamiento', ['fetchTipoMovimiento']),
    ...mapActions('equipo', ['fetchEquipo']),

    triggerMovimiento: async function () {
      this.loading = true
      await this.saveMovimientoEquipamiento(this.movimiento)
      await this.fetchEquipo()
      this.loading = false
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Movimiento de Entrada de Equipamiento */
.card {
  background: rgba(46, 36, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Títulos */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  padding: 24px !important;
}

/* Inputs modernos (text-field, textarea) */
::v-deep .v-text-field .v-input__slot,
::v-deep .v-textarea .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(255, 159, 67, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

/* Hover state */
::v-deep .v-text-field .v-input__slot:hover,
::v-deep .v-textarea .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.3) !important;
}

/* Focus state */
::v-deep .v-input--is-focused .v-input__slot {
  border-color: #ff9f43 !important;
  box-shadow: none !important;
  background: transparent !important;
}

/* Labels */
::v-deep .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
  font-weight: 500;
}

::v-deep .v-input--is-focused .v-label,
::v-deep .v-label--active {
  color: #ffbe76 !important;
  font-weight: 600;
}

/* Input text */
::v-deep .v-text-field__slot input,
::v-deep .v-textarea textarea {
  color: #e0e0e0 !important;
}

/* Iconos en inputs */
::v-deep .v-input__prepend-inner .v-icon,
::v-deep .v-input__append-inner .v-icon,
::v-deep .v-input__append-outer .v-icon {
  color: rgba(255, 159, 67, 0.6) !important;
}

::v-deep .v-input--is-focused .v-input__prepend-inner .v-icon,
::v-deep .v-input--is-focused .v-input__append-inner .v-icon,
::v-deep .v-input--is-focused .v-input__append-outer .v-icon {
  color: #ff9f43 !important;
}

/* Asterisco rojo */
.red--text {
  color: #ff5252 !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.6) !important;
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(255, 159, 67, 0.4) !important;
}

::v-deep .v-btn.error--text:hover {
  background: rgba(255, 82, 82, 0.1) !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Card actions */
::v-deep .v-card-actions {
  padding: 24px !important;
  background: rgba(255, 159, 67, 0.05);
  border-top: 1px solid rgba(255, 159, 67, 0.1);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
